import { Box, Spinner } from "@adfenix/alexandria";
import { useContext } from "react";
import { ReadLayerContext } from "components/ReadLayer/ReadLayerQueryContext";
import { Table } from "components/Datatable";
import { ReadLayer } from "@adfenix/types";
import { CustomerCampaignRow } from "./CustomerCampaignRow";

export const CampaignTable = () => {
  const ctx = useContext(ReadLayerContext);

  if (!ctx) return null;

  const campaigns = ctx.data
    ?.documents as ReadLayer.CustomerCampaignSearchModel[];

  return (
    <Box display="flex" flexDirection="column">
      <Table
        noTableHead
        progressComponent={
          <Box style={{ minHeight: 780 }}>
            <Spinner centered />
          </Box>
        }
        progressPending={!campaigns || !ctx.updateQuery}
        columns={[
          {
            name: "",
            grow: 1,
            cell: (row: ReadLayer.CustomerCampaignSearchModel) => (
              <CustomerCampaignRow campaign={row} />
            )
          }
        ]}
        keyField="id"
        pagination
        paginationServer
        paginationTotalRows={Math.min(
          ctx.data?.totalNumberOfDocuments ?? 0,
          10000
        )}
        onChangePage={page => {
          ctx.updateQuery({ page });
        }}
        onChangeRowsPerPage={pageSize => {
          ctx.updateQuery({ pageSize, page: 1 });
        }}
        paginationRowsPerPageOptions={[10, 15, 20, 25, 30, 50, 75, 100]}
        paginationDefaultPage={ctx.query.page}
        data={campaigns}
      />

      <Box pY="s" style={{ alignSelf: "flex-end" }}>
        Total number of campaigns matching filters:{" "}
        {ctx.data?.totalNumberOfDocuments ?? 0}
      </Box>
    </Box>
  );
};
